import React from 'react';
import { Navigate } from 'react-router-dom';
import NotFoundPage from '../NotFoundPage';
import SEO_REDIRECTS from '../../data/seoRedirects.json';

export default function ArticleLegacyRedirect({ slug }) {
  const target = SEO_REDIRECTS[slug];
  if (!target) {
    return <NotFoundPage />;
  }
  return <Navigate to={target} replace />;
}
